/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createPi } from '../../factoriesAny.js';
export var piDependencies = {
  BigNumberDependencies,
  createPi
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesPi.generated.js
// module id = FFBJ
// module chunks = 3